import { useTranslation } from 'react-i18next';
import Dropdown from 'react-bootstrap/Dropdown';

/**
 * The notifications bell and its panel.
 *
 * `_Notifications.cshtml` is 411 lines of design fixtures — named people, fake
 * avatars under `img/demo/avatars/`, a calendar dated 2090 — and the count beside
 * the bell comes from `HeaderViewComponent.getUnreadNotificationsCount`, which is
 * a documented placeholder returning a hard-coded 0. There is no notification
 * service behind any of it.
 *
 * So the bell and the panel chrome are kept, and the body renders the design's
 * own empty state: an empty `ul.notification` followed by `.notification-empty-msg`,
 * which `_notifications.scss:150` reveals via `:not(:has(*))`. When a real
 * notifications endpoint arrives, the list fills in and the empty state hides
 * itself with no further change here.
 */
export function NotificationsMenu() {
  const { t } = useTranslation();

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        as="button"
        type="button"
        className="btn btn-system no-arrow"
        aria-label={t('OpenNotifications', 'Open notifications')}
      >
        {/* The unread badge (`span.badge.badge-icon.pos-top.pos-end`) is omitted
            while the count is always zero; it belongs here when one exists. */}
        <svg className="sa-icon sa-icon-2x">
          <use href="/myui/icons/sprite.svg#bell" />
        </svg>
      </Dropdown.Toggle>

      <Dropdown.Menu
        renderOnMount
        className="dropdown-menu-animated dropdown-xl p-0"
        aria-label={t('Notifications', 'Notifications')}
      >
        <div className="notification-header rounded-top mb-2">
          <h4 className="m-0">
            {t('Notifications', 'Notifications')}
            <small className="mb-0 opacity-80">{t('UserNotifications', 'User notifications')}</small>
          </h4>
        </div>

        <div className="tab-content tab-notification">
          <div className="tab-pane fade show active" role="tabpanel">
            <div className="custom-scroll h-100">
              <ul className="notification" />
              <div className="notification-empty-msg">
                <svg className="sa-icon sa-icon-5x sa-icon-primary">
                  <use href="/myui/icons/sprite.svg#coffee" />
                </svg>
                <span>{t('NoNewNotifications', 'No new notifications')}</span>
              </div>
            </div>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
